import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Txt from '../atoms/Txt';
import theme from '../../constants/AppTheme';
import Checkbox from '../atoms/Checkbox';
import Btn from '../atoms/Button';
import Row from '../atoms/FlexRow';
import Col from '../atoms/FlexColumn';
import HorSpacer from '../atoms/HorSpacer';
import Icon from '../atoms/IconFA';
import { getProduct } from '../../database/repositories/ProductRepository';
import { normalizeMoney } from '../../utils/util';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.lightGray};
  margin: 10px 20px;
  padding: 10px 15px;
  border-radius: 10px;
`;

const Cover = styled.img`
  width: 200px;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
  @media (max-width: 768px) {
    width: 130px;
  }
`;

function FavouriteRow({ prodId, checked, onCheck, style, ...props }) {
  const [prod, setProd] = useState(null);

  useEffect(() => {
    getProduct(prodId).then(setProd).catch(console.error);
  }, [prodId]);

  if (prod)
    return (
      <Container>
        <Row>
          <Checkbox value={checked} onClick={onCheck} />
          <HorSpacer size={20} />
          <Cover src={prod.pictures[0]} alt="" />
          <HorSpacer size={20} />
          <Col align="flex-start">
            <Txt size={20} color={theme.red}>
              {prod.name.toUpperCase()}
            </Txt>
            <Txt size={20} color={theme.red}>
              {prod.condition.toUpperCase()}
            </Txt>
            <Txt size={18} bold>
              {normalizeMoney(prod.price)}
            </Txt>
            <Txt size={18}>12x &bull; {normalizeMoney(prod.price / 12)}</Txt>
          </Col>
        </Row>
        <Row>
          <Btn href={`/produto/detalhes/${prodId}`} color={theme.red} fontColor="white" fontSize="14" bold>
            VER PRODUTO
          </Btn>
          {/* <Icon code="fas fa-ellipsis-v" color={theme.gray} size={30} margin="0 10px 0 20px" /> */}
        </Row>
      </Container>
    );

  return null;
}

export default FavouriteRow;
